import * as THREE from 'three';
import { Fiko3DYazi } from './Fiko3DYazi';
import { FikoEksen } from './FikoEksen';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';
import { FikoVektor3D } from './FikoVektor3d';

declare var DxfParser: any;

export class FikoDxfCizici extends FikoGrup {
    override type: any = "FikoDxfCizici";
    /** */

    dxfParcalayici = new DxfParser();
    parcalanmisDxf: any;
    tumVarliklar: any[] = [];
    /** */
    delikGruplari: any[] = new Array();

    constructor(public override sahne?: FikoSahne, public dxfStr: string = null) {
        super(sahne);
        this.name = "Dxf Cizimleri"
        if (dxfStr) {
            this.parcalanmisDxf = this.dxfParcalayici.parseSync(dxfStr);
        }

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].simge = "./simgeler/3d.webp";
    }

    dxfParcala() {
        this.parcalanmisDxf = this.dxfParcalayici.parseSync(this.dxfStr);
    }

    varliklariOku() {
        var data = this.parcalanmisDxf;
        var grup = new THREE.Object3D();
        var entities = [];

        // Create entities from dxf object (data)
        let sonPoz = new FikoVektor3D();
        var i, varlik, veri;
        for (i = 0; i < data.entities.length; i++) {
            varlik = data.entities[i];
            veri = this.varlikCiz(varlik, data);

            if (veri) {
                if (varlik.type == "INSERT") {
                    // veri.translateX(-varlik.position.x);
                    // veri.translateY(-varlik.position.y);
                    // veri.translateZ(-varlik.position.z);

                    sonPoz = new FikoVektor3D(varlik.position.x, varlik.position.y, varlik.position.z)
                } else {
                    // if (varlik.type == "DIMENSION") {
                    //     veri.translateX(sonPoz.x);
                    //     veri.translateY(sonPoz.y);
                    //     veri.translateZ(sonPoz.z);
                    // }
                }
                // veri.name = varlik.name;
                // (veri as FikoGrup).agactaGorunur = true;
                entities.push(veri);
            }
            veri = null;
        }
        if (sonPoz) {
            this.translateX(sonPoz.x);
            this.translateY(-sonPoz.y);
            this.translateZ(-sonPoz.z);
        }
        this.scale.x *= -1
        this.scale.z *= -1
        this.ekle(...entities);
    }

    varliklariOku1() {
        this.tumVarliklar = [];
        Object.keys(this.parcalanmisDxf.blocks).forEach(element => {
            const block = this.parcalanmisDxf.blocks[element];

            var i, varlik, nesne: any;
            for (i = 0; i < block?.entities?.length; i++) {
                varlik = block.entities[i];
                nesne = this.varlikCiz(varlik, nesne);

                if (nesne) {
                    this.tumVarliklar.push(nesne);
                    this.ekle(nesne)
                }
                nesne = null;
            }
        });
    }

    varlikCiz(varlik: any, veri: any) {
        let mesh;
        if (varlik.type === "CIRCLE" || varlik.type === "ARC") {
            mesh = this.cizArc(varlik, veri);
        } else if (
            varlik.type === "LWPOLYLINE" ||
            varlik.type === "LINE" ||
            varlik.type === "POLYLINE"
        ) {
            mesh = this.cizCizgi(varlik, veri);
        } else if (varlik.type === "SPLINE") {
            mesh = this.cizSpline(varlik, veri);
        } else if (varlik.type === "TEXT") {
            mesh = this.cizYazi(varlik, veri);
        } else if (varlik.type === "DIMENSION") {
            mesh = this.cizOlcu(varlik, veri);
        } else if (varlik.type === 'INSERT') {
            mesh = this.cizBlok(varlik, veri);
        }
        // console.log(varlik);
        //@ts-ignore
        return mesh;
    }

    // raycast(raycaster: Raycaster, intersects: Intersection[]): void {
    //     // let _inverseMatrix = new THREE.Matrix4();
    //     let kesisenler = raycaster.intersectObjects(this.children, false);

    //     if (kesisenler.length > 0) {
    //         //@ts-ignore
    //         (kesisenler[0].object as THREE.Line).material.color.set(0x0000ff)
    //         // kesisenler[0].object = this;
    //         intersects.push(kesisenler[0]);
    //     }
    // }

    cizArc(varlik: any, veri: any) {
        var aciBas, aciSon;
        if (varlik.type === "CIRCLE") {
            aciBas = varlik.startAngle || 0;
            aciSon = aciBas + 2 * Math.PI;
        } else {
            aciBas = varlik.startAngle;
            aciSon = varlik.endAngle;
        }

        var curve = new THREE.ArcCurve(0, 0, varlik.radius, aciBas, aciSon, false);

        var points = curve.getPoints(500);
        var geometry = new THREE.BufferGeometry().setFromPoints(points);



        // var material = new THREE.LineBasicMaterial({
        //     color: this.renkCevir(varlik, veri),
        // });

        var ark = new THREE.Line(geometry);
        ark.position.x = varlik.center.x;
        ark.position.y = varlik.center.y;
        ark.position.z = varlik.center.z;
        //@ts-ignore
        ark.material.color.set(0x000000);

        ark.userData['dxfVeri'] = varlik;

        return ark;
    }

    cizCizgi(varlik: any, veri: any) {
        var geometry = new THREE.BufferGeometry();
        var color = this.renkCevir(varlik, veri);
        // var material;
        var lineType;
        var vertex;
        var startPoint;
        var endPoint;
        var bulgeGeometry;
        var bulge;
        var i;
        var line;

        if (!varlik.vertices) return;

        const noktalar = []
        // create geometry
        for (i = 0; i < varlik.vertices.length; i++) {

            vertex = varlik.vertices[i];
            noktalar.push(new FikoVektor3D(vertex.x, vertex.y, 0));
        }
        // console.log(noktalar)
        // material = new THREE.LineBasicMaterial({ linewidth: 1, color: color });

        line = new THREE.Line(geometry.setFromPoints(noktalar));
        //@ts-ignore
        line.material.color.set(0x000000);

        line.userData['dxfVeri'] = varlik;
        return line;
    }

    cizSpline(varlik: any, veri: any) {
        var color = this.renkCevir(varlik, veri);

        var points = varlik.controlPoints.map(function (vec: { x: number; y: number; }) {
            return new THREE.Vector2(vec.x, vec.y);
        });

        var interpolatedPoints: any[] = [];
        var curve;
        if (
            varlik.degreeOfSplineCurve === 2 ||
            varlik.degreeOfSplineCurve === 3
        ) {
            var i = 0;
            for (i = 0; i + 2 < points.length; i = i + 2) {
                if (varlik.degreeOfSplineCurve === 2) {
                    curve = new THREE.QuadraticBezierCurve(
                        points[i],
                        points[i + 1],
                        points[i + 2]
                    );
                } else {
                    curve = new THREE.QuadraticBezierCurve3(
                        points[i],
                        points[i + 1],
                        points[i + 2]
                    );
                }
                interpolatedPoints.push.apply(
                    interpolatedPoints,
                    curve.getPoints(50)
                );
            }
            if (i < points.length) {
                curve = new THREE.QuadraticBezierCurve3(
                    points[i],
                    points[i + 1],
                    points[i + 1]
                );
                interpolatedPoints.push.apply(
                    interpolatedPoints,
                    curve.getPoints(500)
                );
            }
        } else {
            curve = new THREE.SplineCurve(points);
            interpolatedPoints = curve.getPoints(100);
        }

        var geometry = new THREE.BufferGeometry().setFromPoints(
            interpolatedPoints
        );
        var material = new THREE.LineBasicMaterial({
            linewidth: 1,
            color: color,
        });
        var splineObject = new THREE.Line(geometry, material);

        splineObject.userData['dxfVeri'] = varlik;

        return splineObject;
    }


    cizYazi(varlik: any, veri: any) {
        var geometry, material, text;

        geometry = new Fiko3DYazi(this.sahne, (varlik.text as string), varlik.textHeight, this.renkCevir(varlik, veri))//new THREE.TextGeometry(varlik.text, { font: font, height: 0, size: varlik.textHeight || 12 });

        geometry.position.x = varlik.startPoint.x;
        geometry.position.y = varlik.startPoint.y;
        geometry.position.z = varlik.startPoint.z;

        geometry.hazirla(null);

        return geometry;
    }

    cizOlcu(varlik: any, veri: any) {
        // var sonuc;
        // if (varlik.dimensionType == 161) {
        //     sonuc = new FikoLinearOlcu(
        //         new FikoVektor3D(varlik.linearOrAngularPoint1.x, varlik.linearOrAngularPoint1.y, varlik.linearOrAngularPoint1.z),
        //         new FikoVektor3D(varlik.linearOrAngularPoint2.x, varlik.linearOrAngularPoint2.y, varlik.linearOrAngularPoint2.z),
        //         new FikoVektor3D(0, 1, 0)
        //     );
        //     sonuc.hazirla(null);
        // }

        // return sonuc;
        var block = veri.blocks[varlik.block];

        if (!block || !block.entities) return null;

        var grup = new FikoGrup(this.sahne);
        grup.name = "Ölçümler"
        grup.komutlar = [
            {
                baslik: "Gizle / Göster",
                simge: "eye",
                tiklandi: () => {
                    grup.visible = !grup.visible;
                }
            }
        ]

        // if(entity.anchorPoint) {
        // grup.position.x = block.anchorPoint.x;
        // grup.position.y = block.anchorPoint.y;
        // grup.position.z = block.anchorPoint.z;
        // }


        for (var i = 0; i < block.entities.length; i++) {
            var childEntity = this.varlikCiz(block.entities[i], veri);
            if (childEntity) {
                grup.add(childEntity)
            };
        }
        // grup.name = "Ölçüm Grubu";
        // grup.agactaGorunur = true;
        return grup;
    }

    cizBlok(varlik: any, veri: any) {
        var blok = veri.blocks[varlik.name];

        if (!blok.entities) return null;

        var grup = new FikoGrup(this.sahne)
        grup.name = varlik.name
        grup.userData['FikoArayuz'].agactaGorunur = true;


        let eksen = new FikoEksen(this.sahne, "Eksen");
        eksen.userData['FikoArayuz'].agactaGorunur = true;
        grup.add(eksen)
        eksen.hazirla(this.sahne)

        if (varlik.xScale) grup.scale.x = varlik.xScale;
        if (varlik.yScale) grup.scale.y = varlik.yScale;


        if (varlik.rotation) {
            grup.rotation.z = varlik.rotation * Math.PI / 180;
            grup.rotation.x = varlik.rotation * Math.PI / 180;
            grup.rotation.y = varlik.rotation * Math.PI / 180;
        }

        if (varlik.position) {
            grup.position.x = varlik.position.x;
            grup.position.y = varlik.position.y;
            grup.position.z = varlik.position.z;
        }

        for (var i = 0; i < blok.entities.length; i++) {
            var childEntity = this.varlikCiz(blok.entities[i], veri);
            if (childEntity) {
                grup.add(childEntity)
            };
        }


        return grup;
    }


    renkCevir(varlik: any, veri: any) {
        var renk = 0x000000; // default
        if (varlik.color) renk = varlik.color;
        else if (
            veri.tables &&
            veri.tables.layer &&
            veri.tables.layer.layers[varlik.layer]
        )
            renk = veri.tables.layer.layers[varlik.layer].color;

        if (renk == null || renk === 0xffffff) {
            renk = 0x000000;
        }
        return renk;
    }

    groupBy(list: any[], keyGetter: any) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    analizCaplar() {
        this.tumVarliklar.forEach(element => {
            let dahaKucukVar = false;
            let dahaBuyukVar = false;
            if (element.userData.dxfVeri.type == "CIRCLE") {
                this.tumVarliklar.forEach(altElement => {
                    if (altElement.userData.dxfVeri.type == "CIRCLE") {
                        if (element.userData.dxfVeri.center.x == altElement.userData.dxfVeri.center.x && element.userData.dxfVeri.center.y == altElement.userData.dxfVeri.center.y) {
                            if (element.userData.dxfVeri.radius != altElement.userData.dxfVeri.radius) {
                                if (element.userData.dxfVeri.radius > altElement.userData.dxfVeri.radius) {
                                    dahaKucukVar = true;
                                } else {
                                    dahaBuyukVar = true;
                                }
                            }
                        }
                    }
                });

                if (dahaKucukVar && dahaBuyukVar) {
                    element.userData.dxfVeri.delikTipi = "Ara Delik";
                } else if (dahaKucukVar) {
                    element.userData.dxfVeri.delikTipi = "Kafa Yeri";
                } else if (dahaBuyukVar) {
                    element.userData.dxfVeri.delikTipi = "Delik";
                } else {
                    element.userData.dxfVeri.delikTipi = "Delik";
                }
            }
        });
    }

    delikleriGrupla() {

    }

    caplariBul(cap: number): any[] {
        const rslt: any[] = []
        this.tumVarliklar.forEach(element => {
            // console.log(element)
            if (element.userData.dxfVeri.type == "CIRCLE" && (element.userData.dxfVeri.radius * 2) == cap) {
                rslt.push(element);
            }
        });
        return rslt
    }

}